import React from 'react';

import {
  StepFormFieldsTitle,
  StyledStepContentSeparatorDiv,
} from 'app/procedures/components/structures';

import {StepTaskFieldWrapper} from './step-form-fields/StepTaskFieldWrapper';

import type {TaskProgressStepFieldType} from 'app/tasks/types';
import type {StepFieldType} from 'sweet-types';

type Props = {
  stepFields?: Array<StepFieldType>;
  fieldsProgress: Record<string, TaskProgressStepFieldType>;
  blocked?: boolean;
  inputListener: (fieldId: string, value: any) => Promise<any>;
};
export const ProcedureStepFields = ({
  stepFields,
  inputListener,
  fieldsProgress,
  blocked = false,
}: Props) => {
  return stepFields != null && stepFields.length > 0 ? (
    <StyledStepContentSeparatorDiv className="files">
      <StepFormFieldsTitle />
      <ul className="list-group">
        {stepFields.map((field) => (
          <StepTaskFieldWrapper
            blocked={blocked}
            key={field.id}
            field={field}
            progress={fieldsProgress[field.id]}
            inputListener={inputListener}
          />
        ))}
      </ul>
    </StyledStepContentSeparatorDiv>
  ) : null;
};
